export default __webpack_public_path__ + "static/media/1-6-4.ccb79c97.jpg";